<template>
  <div :class="classes">
    <label v-if="label">
      <slot name="label" :label="label">{{label}}</slot>
    </label>
    <n-button v-for="(item, idx) in items" :key="`button-group-item-${idx}`" @click="selected = item" :value="selected == item" :info="selected == item" outline class="mx-0">
      <slot name="item-label" :item="item">{{item}}</slot>
    </n-button>
  </div>
</template>

<script type="text/javascript">

  import Selectable from '../../mixins/selectable'

  export default {

    mixins: [Selectable],

    props: {
      label: { type: String },
      items: { type: Array, required: true },
      round: { type: Boolean },
    },

    computed: {
      classes() {
        return {
          'button-group': true,
          'button-group--round': this.round,
        }
      }
    },
  }
</script>

<style lang="scss">
  .button-group {
    .btn { border-radius: 0; }

    :not(.btn:first-of-type) { border-left: none; }
    
    &--round {
      .btn:first-of-type { border-radius: 28px 0 0 28px; }
      .btn:last-of-type { border-radius: 0 28px 28px 0; }
    }
  }
</style>